'use client';

import { useQuery } from '@tanstack/react-query';
import { useTranslations } from 'next-intl';
import ProviderCard from '@/components/entities/providers/ProviderCard';
import { Icon } from '@/components/entities/Sprite/Icon';
import { ShowAllButton } from '@/components/shared';
import { SliderWrapper } from '@/components/shared/SliderWrapper';
import { AppRoutes } from '@/i18n/constants';
import { Link } from '@/i18n/routing';
import { lobbyQueryOptions } from '@/queries/lobby/lobby.queries';

export default function LobbyProviders() {
  const t = useTranslations('lobby');

  const { data: providersList } = useQuery(lobbyQueryOptions.providers());

  const slicedProviderList = providersList?.items?.slice(0, 11);

  return (
    <section className="mb-5.25 3xl:mb-8.25">
      <Link href={AppRoutes.providers} className="inline-flex justify-between items-center mb-2.25 3xl:mb-2.25">
        <div className="group flex items-center gap-1">
          <div className="relative flex items-center gap-1 h-6 font-medium text-[1.125rem] leading-5.5 3xl:leading-6">
            <span className="text-white">{t('providers')}</span>
            <span
              aria-hidden
              className="max-lg:hidden absolute inset-0 bg-main-front-gradient text-gradient opacity-0 transition-opacity duration-200 group-hover:opacity-100 group-active:opacity-100"
            >
              {t('providers')}
            </span>
            <Icon
              name="lobby-title-arrow"
              className="size-4 mt-px text-white transition-colors duration-200 group-hover:text-c100 group-active:text-c100"
            />
          </div>
        </div>
      </Link>

      <div className="-mx-4 relative overflow-x-clip lg:-mx-10 3xl:mr-0">
        <SliderWrapper>
          <div className="h-27 md:h-auto w-max pl-4 pr-4 lg:pl-10 lg:pr-10 3xl:pr-0">
            <div className="grid grid-flow-col grid-rows-2 md:grid-rows-1 auto-cols-[7.5rem] md:auto-cols-[11.125rem] gap-2 md:gap-2 w-max">
              {slicedProviderList?.map((provider, index) => (
                <div key={provider.id} className="relative h-12.5 md:h-auto">
                  <div className="absolute inset-0 rounded-[0.75rem] shadow-lg pointer-events-none z-0" />

                  <ProviderCard
                    hideName
                    variant="lobby"
                    provider={provider}
                    priority={index === 0}
                  />
                </div>
              ))}
              <div className="relative h-12.5 md:h-auto">
                <div className="absolute inset-0 rounded-md md:rounded-[0.75rem] shadow-lg pointer-events-none z-0" />
                <ShowAllButton
                  href={AppRoutes.providers}
                  className="h-full w-full min-h-0 rounded-md md:rounded-[0.75rem] px-2.5 py-2"
                />
              </div>
            </div>
          </div>
        </SliderWrapper>
        <div
          className="pointer-events-none absolute top-0 -right-0.5 w-23 h-27 md:h-21 z-10 bg-[linear-gradient(270deg,rgba(35,19,51,0.8)_0%,rgba(35,19,51,0.4)_50%,rgba(35,19,51,0)_100%)]"
        />
      </div>
    </section>
  );
}
